import { ROUTES } from 'constant/routes';
import { PageOptions } from 'types';

export const mapPageRouteToPageType = {
  [ROUTES.HISTORY]: PageOptions.history,
  [ROUTES.FOLLOWING]: PageOptions.following,
  [ROUTES.NOTES]: PageOptions.notes,
  [ROUTES.SIMILAR_SHOPS]: PageOptions.similarShops,
  [ROUTES.USER]: PageOptions.user,
};

export const mapPageTypeToTitle = {
  [PageOptions.history]: 'Recently viewed shops',
  [PageOptions.following]: 'Shops I follow',
  [PageOptions.myBusinesses]: 'My shops',
  [PageOptions.similarShops]: 'Similar shops',
  [PageOptions.user]: "User's shops",
};
